(function () {
  "use strict";

  var LAYOUT_ALLOWED = {
    "hongaarse punt": true,
    "rechte plank": true,
    tegel: true,
    visgraat: true,
    "walvisgraat xl": true,
    "weense punt": true,
  };

  function ufWalvisgraatXlFromText(title, productType) {
    var blob = (String(title || "") + " " + String(productType || "")).toLowerCase();
    return blob.indexOf("visgraat xl") !== -1 || blob.indexOf("walvisgraat") !== -1;
  }

  function layoutFingerprint(tags, title, productType) {
    var keys = [];
    var isWalvisXl = ufWalvisgraatXlFromText(title, productType);
    (tags || []).forEach(function (tag) {
      var t = String(tag || "");
      var colon = t.indexOf(":");
      if (colon === -1) return;
      var prefix = t.slice(0, colon).trim().toLowerCase();
      var value = t.slice(colon + 1).trim().toLowerCase();
      if (prefix === "lay-out" && LAYOUT_ALLOWED[value]) {
        if (isWalvisXl && value === "visgraat") return;
        keys.push(value);
      }
    });
    if (isWalvisXl) keys.push("walvisgraat xl");
    keys.sort();
    var out = [];
    keys.forEach(function (k) {
      if (out.indexOf(k) === -1) out.push(k);
    });
    return out.join("|");
  }

  /** Zelfde normalisatie als collectiefilter: dryback→plak, klik→click. */
  function normalizePvctypeValue(value) {
    var n = String(value || "")
      .trim()
      .toLowerCase()
      .replace(/\s+/g, " ");
    if (n === "dryback" || n === "dry-back") return "plak";
    if (n === "klik") return "click";
    return n;
  }

  var PVCTYPE_ALLOWED = { plak: true, click: true, "loose lay": true };

  function pvctypeFingerprint(tags) {
    var keys = [];
    (tags || []).forEach(function (tag) {
      var t = String(tag || "").trim();
      if (!t) return;
      var colon = t.indexOf(":");
      var k = "";
      if (colon === -1) {
        k = normalizePvctypeValue(t);
      } else {
        var prefix = t.slice(0, colon).trim().toLowerCase().replace(/\s+/g, " ");
        var rest = t.slice(colon + 1).trim();
        var tl = t.toLowerCase();
        if (prefix === "soort filter" || prefix === "pvctype") {
          k = normalizePvctypeValue(rest);
        } else if (prefix === "soort") {
          k = normalizePvctypeValue(rest);
        } else if (prefix === "specificatie" && tl.indexOf("soort") !== -1) {
          var parts = t.split(":");
          k = normalizePvctypeValue(parts[parts.length - 1] || "");
        }
      }
      if (PVCTYPE_ALLOWED[k] && keys.indexOf(k) === -1) keys.push(k);
    });
    keys.sort();
    return keys.join("|");
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/"/g, "&quot;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
  }

  function fetchSiblingPage(query, page) {
    var url =
      "/search?q=" +
      encodeURIComponent(query) +
      "&type=product&view=uf-product-siblings&page=" +
      page;
    return fetch(url, { credentials: "same-origin" }).then(function (res) {
      if (!res.ok) throw new Error("Sibling search failed (" + res.status + ")");
      return res.json();
    });
  }

  function fetchAllSiblings(query) {
    var page = 1;
    var all = [];

    function next() {
      return fetchSiblingPage(query, page).then(function (data) {
        all = all.concat(data.products || []);
        if (data.has_more) {
          page += 1;
          return next();
        }
        return all;
      });
    }

    return next();
  }

  function renderSwatches(root) {
    if (!root || !root.getAttribute) return;
    var groupKey = root.getAttribute("data-uf-group-key");
    if (!groupKey) return;

    var matchSoort = root.getAttribute("data-uf-match-soort") === "true";
    var soortFp = root.getAttribute("data-uf-soort-fp") || "";
    var pvctypeFp = root.getAttribute("data-uf-pvctype-fp") || "";
    var currentId = String(root.getAttribute("data-uf-current-id") || "");
    var query = 'tag:"Productgroep: ' + groupKey.replace(/"/g, '\\"') + '"';

    root.classList.add("uf-lf-color-swatches--loading");

    fetchAllSiblings(query)
      .then(function (products) {
        var html = "";
        products.forEach(function (p) {
          if (matchSoort && layoutFingerprint(p.tags, p.title, "") !== soortFp) return;
          /* Klik alleen bij klik, plak alleen bij plak (zelfde Type-fingerprint). */
          if (pvctypeFingerprint(p.tags) !== pvctypeFp) return;
          if (!p.image) return;
          var isCurrent = String(p.id) === currentId;
          var previewSrc = p.preview || p.image || "";
          var previewImages = [];
          if (p.images && p.images.length) {
            p.images.forEach(function (u) {
              if (u) previewImages.push(String(u));
            });
          }
          if (!previewImages.length && previewSrc) previewImages.push(previewSrc);
          html +=
            '<a href="' +
            escapeHtml(p.url) +
            '" class="uf-lf-color-swatch' +
            (isCurrent ? " is-current" : "") +
            '" role="listitem" aria-label="' +
            escapeHtml(p.title) +
            '"' +
            (isCurrent ? ' aria-current="page"' : "") +
            ' data-product-id="' +
            escapeHtml(String(p.id)) +
            '" data-preview-src="' +
            escapeHtml(previewSrc) +
            '" data-preview-images="' +
            escapeHtml(JSON.stringify(previewImages)) +
            '" data-title="' +
            escapeHtml(p.title || "") +
            '"' +
            (p.price
              ? ' data-price="' + escapeHtml(String(p.price)) + '"'
              : "") +
            (p.compare_at_price
              ? ' data-compare-price="' + escapeHtml(String(p.compare_at_price)) + '"'
              : "") +
            ">" +
            '<img src="' +
            escapeHtml(p.image) +
            '" alt="" width="72" height="72" loading="lazy">' +
            "</a>";
        });
        root.innerHTML = html;
        root.classList.remove("uf-lf-color-swatches--loading");
        if (!html) {
          var opt = root.closest(".uf-lf-option--color-swatches");
          var wrap = root.closest(".uf-lf-product__options--swatches-only");
          if (opt) opt.remove();
          if (wrap) wrap.remove();
        }
        try {
          root.dispatchEvent(
            new CustomEvent("uf-lf-color-swatches:rendered", {
              bubbles: true,
              detail: { root: root, products: products },
            })
          );
        } catch (e) {}
      })
      .catch(function () {
        root.classList.remove("uf-lf-color-swatches--loading");
      });
  }

  function renderAll(scope) {
    var ctx = scope || document;
    var nodes = ctx.querySelectorAll
      ? ctx.querySelectorAll("[data-uf-lf-color-swatches]")
      : [];
    Array.prototype.forEach.call(nodes, renderSwatches);
  }

  window.UF_LF_COLOR_SWATCHES = {
    render: renderSwatches,
    renderAll: renderAll,
    layoutFingerprint: layoutFingerprint,
    pvctypeFingerprint: pvctypeFingerprint,
  };

  renderAll(document);
})();
